import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { InputDate } from '../../common/InputDate'
import { changeFilter, selectFilterByKey } from '../store/slice'

export const DateOrdered = ({ appendStyleContainer }) => {
  const dispatch = useDispatch()

  const from = useSelector(selectFilterByKey('from'))
  const to = useSelector(selectFilterByKey('to'))

  const onFromChange = (from) => {
    dispatch(changeFilter({ from, page: 1 }))
  }

  const onToChange = (to) => {
    dispatch(changeFilter({ to, page: 1 }))
  }

  return (
    <div className="dFlex gap1 alignItemsCenter" style={appendStyleContainer}>
      <Translate
        value="userManagement.orderManagement.DATE_ORDERED"
        className="fw600"
      />
      <InputDate
        defaultDate={from ? from : undefined}
        value={from}
        onChange={onFromChange}
        placeholder={UseI18n('screening.FROM')}
      />
      <InputDate
        defaultDate={to ? to : undefined}
        value={to}
        onChange={onToChange}
        placeholder={UseI18n('screening.TO')}
      />
    </div>
  )
}
